import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureHomepagePopularPinsHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureHomepagePopularPinsHttp must be called before use')
  return http
}

export const listHomepagePopularPins = () => client().get('/homepage-popular-pins', { routeId: 'visualGame.homepagePopularPins.list' })
export const createHomepagePopularPin = body => client().post('/homepage-popular-pins', { body, routeId: 'visualGame.homepagePopularPins.create' })
export const updateHomepagePopularPin = (id, body) => client().put(`/homepage-popular-pins/${encodeURIComponent(id)}`, { body, routeId: 'visualGame.homepagePopularPins.update' })
export const deleteHomepagePopularPin = id => client().delete(`/homepage-popular-pins/${encodeURIComponent(id)}`, { routeId: 'visualGame.homepagePopularPins.delete' })
export const reorderHomepagePopularPins = ids => client().put('/homepage-popular-pins/reorder', { body: { ids }, routeId: 'visualGame.homepagePopularPins.reorder' })
